import { render, staticRenderFns } from "./MatrixCanvas.vue?vue&type=template&id=688f03d3&scoped=true&"
import script from "./MatrixCanvas.vue?vue&type=script&lang=js&"
export * from "./MatrixCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MatrixCanvas.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MatrixCanvas.vue?vue&type=style&index=1&id=688f03d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f03d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
